global.businessCategoryList = global.API_ADMIN_URL+'businessCategoryList/';
global.adminAddBusinessCategory = global.API_ADMIN_URL+'adminAddBusinessCategory/';
global.adminEditBusinessCategory = global.API_ADMIN_URL+'adminEditBusinessCategory/';
global.businessCategoryDetails = global.API_ADMIN_URL+'businessCategoryDetails/';
global.businessCategoryDelete = global.API_ADMIN_URL+'businessCategoryDelete/';
global.businessCategoryStatus = global.API_ADMIN_URL+'businessCategoryStatus/';